import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SalesChannelType } from "@aitisal/contracts/common";
import { getSalesChannelByType } from "@aitisal/sdk/restaurant/sales-channel";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useSession } from "../stores/sessionStore";
import { useBrandingConfig } from "../utils/brandingConfig";

export const Route = createFileRoute("/c")({
  component: RouteComponent,
});

function RouteComponent() {
  const { setPointOfOrder }: any = useSession();
  const { brandId } = useBrandingConfig();

  const { data: webPointOfOrderData } = useQuery({
    queryKey: ["web-point-of-order-data", brandId],
    queryFn: async () => {
      const response: any = await getSalesChannelByType(
        brandId,
        SalesChannelType.WEB,
      );
      return response?.data;
    },
    enabled: Boolean(brandId),
    retry: false,
  });

  useEffect(() => {
    if (webPointOfOrderData) {
      setPointOfOrder(webPointOfOrderData);
    }
  }, [webPointOfOrderData, setPointOfOrder]);

  return <Outlet />;
}